export default{
    methods: {
        instantScrollTop: () => {
          window.scrollTo({
            top: 0,
            behavior: "instant"
          });
        }
    }
  }